// ======================================================================
// File: ruleService.js
// Module: PPE → FMS → Automation
// Purpose: API communication layer for Automation Rules
// ======================================================================

import axiosClient from "../../../../../api/axiosClient";

// ----------------------------------------------------------------------
// BASE URL (Aligned with existing FMS APIs)
// ----------------------------------------------------------------------
const BASE_URL = "/api/ppe/fms";

const ruleService = {

  // ------------------------------------------------------------
  // GET ALL RULES
  // ------------------------------------------------------------
  getRules: async () => {
    const res = await axiosClient.get(`${BASE_URL}/rules`);
    return res.data;
  },

  // ------------------------------------------------------------
  // GET SINGLE RULE
  // ------------------------------------------------------------
  getRuleById: async (id) => {
    const res = await axiosClient.get(`${BASE_URL}/rules/${id}`);
    return res.data;
  },

  // ------------------------------------------------------------
  // CREATE RULE
  // ------------------------------------------------------------
  createRule: async (payload) => {
    const res = await axiosClient.post(`${BASE_URL}/rules/create`, payload);
    return res.data;
  },

  // ------------------------------------------------------------
  // UPDATE RULE
  // ------------------------------------------------------------
  updateRule: async (id, payload) => {
    const res = await axiosClient.put(`${BASE_URL}/rules/${id}`, payload);
    return res.data;
  },

  // ------------------------------------------------------------
  // ENABLE / DISABLE RULE
  // ------------------------------------------------------------
  toggleRuleStatus: async (id, is_active) => {
    const res = await axiosClient.post(
      `${BASE_URL}/rules/${id}/status`,
      { is_active }
    );
    return res.data;
  },

  // ------------------------------------------------------------
  // GET EVENT FIELDS (Condition Builder)
  // ------------------------------------------------------------
  getEventFields: async (event_type) => {
    const res = await axiosClient.get(
      `${BASE_URL}/event-fields`,
      {
        params: { event_type }
      }
    );
    return res.data;
  },

  // ------------------------------------------------------------
  // GET RULE EXECUTION LOGS
  // ------------------------------------------------------------
  getRuleLogs: async (rule_id) => {
    const res = await axiosClient.get(
      `${BASE_URL}/rules/${rule_id}/logs`
    );
    return res.data;
  }

};

export default ruleService;
